import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useMerchantAccountStore = create()(
    persist(
        (set) => ({
            refetchMerchantAccounts: false,
            storeRefetchMerchantAccounts: (refetchMerchantAccounts) => set(() => ({ refetchMerchantAccounts: refetchMerchantAccounts })),
            query: getInitialQuery(),
            storeQuery: (query) => set(() => ({ query: query })),

            merchantAccountDetails: {},
            storeMerchantAccountDetails: (merchantAccountDetails) => set(() => ({ merchantAccountDetails: merchantAccountDetails }))
        }),
        {
            name: 'merchant-account-storage'
        }
    )
);

export default useMerchantAccountStore;